(() => {
  if (window.mitoSyneBundleCartInitialized) return;
  window.mitoSyneBundleCartInitialized = true;

  document.addEventListener("click", async (event) => {
    const button = event.target.closest("[data-ms-bundle-add]");
    if (!button || button.disabled) return;

    const status = button.parentElement.querySelector("[data-ms-bundle-status]");
    const originalLabel = button.textContent.trim();
    let items;

    try {
      items = JSON.parse(button.dataset.items || "[]");
    } catch {
      items = [];
    }

    if (!items.length) {
      if (status) status.textContent = "This bundle is currently unavailable.";
      return;
    }

    button.disabled = true;
    button.textContent = "Adding...";
    if (status) status.textContent = "";

    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) throw new Error("Cart request failed");
      window.location.assign(window.routes.cart_url);
    } catch {
      button.disabled = false;
      button.textContent = originalLabel;
      if (status) status.textContent = "Unable to add the bundle. Please try again.";
    }
  });
})();
